import image from '../images/icons_assets/restaurant chef B.jpg';

export const HERO = [
  {
    id: 1,
    title: 'Little Lemon',
    subtitle: 'Chicago',
    description:
      'We are a family owned Mediterranean restaurant, focused on traditional recipes served with a modern twist.',
    buttonName: 'Reserve a Table',
    image: image,
  },
];
